import type { Being, BeingState } from '../../../models/Being';
import type { Surroundings } from '../../../models/Surroundings';
import { DirectionsVectors } from '../../../models/constants';
import type { IBeingState } from './IBeingState';
import { bestDirection } from '../scoring';

export class FleeingState implements IBeingState {
    static readonly stateName = 'Fleeing Danger';

    get allowInterrupt(): boolean {
        return true;
    }

    canEnter(_being: Being, surroundings: Surroundings): boolean {
        return surroundings.isInDanger;
    }

    tick(being: Being, surroundings: Surroundings): BeingState {
        if (!surroundings.isInDanger) return 'Exploring';

        being.directionTicks = 0;
        being.moveDirection = bestDirection(being, surroundings, true);
        const vec = DirectionsVectors.get(being.moveDirection)!;
        being.translate(vec.dx, vec.dz);

        return FleeingState.stateName;
    }
}
